import React, { useState, useEffect } from "react";
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/back-to-school.webp";
import BlinkingText from "../../BlinkingText";
import RelatedLinks from "../RelatedLinks";
import MainCalculatorsList from "./MainCalculators";
const TITLE =
  "كم باقي على المدرسة في السعودية 2026 - العد التنازلي للمدرسة";
const DESCRIPTION = "كم باقي على بداية العام الدراسي الجديد في المملكة العربية السعودية 2026، تاريخ العام الدراسي الجديد في السعودية، متى يبدأ العام الدراسي في السعودية 2026، كم يوم باقي للعام الدراسي الجديد في المملكة العربية السعودية 2026، موعد بداية العام الدراسي 2026 في السعودية، كم باقي للمدرسة في السعودية، موعد بدء الدراسة في المملكة العربية السعودية 2026، متى يبدأ العام الدراسي الجديد في السعودية 2026، العام الدراسي في المملكة العربية السعودية 2026، العد التنازلي لبداية المدرسة في السعودية 2026، كم باقي على بداية الدراسة في السعودية 2026، تاريخ بداية الدراسة في المملكة العربية السعودية 2026، موعد بداية الدراسة 2026 في السعودية، متى يبدأ العام الدراسي في السعودية 2026، العد التنازلي للعام الدراسي في المملكة العربية السعودية 2026.";
const KEYWORDS = "كم باقي على العام الدراسي في السعودية 2026، بداية العام الدراسي 2026 في السعودية، متى يبدأ العام الدراسي في السعودية 2026، تاريخ بداية العام الدراسي 2026 في المملكة العربية السعودية، العد التنازلي لبداية العام الدراسي 2026 في السعودية، كم يوم باقي لبداية المدرسة في السعودية 2026، موعد بداية العام الدراسي في المملكة العربية السعودية 2026، العد التنازلي للمدرسة في السعودية 2026، كم باقي لبداية العام الدراسي 2026 في السعودية، تاريخ بداية الدراسة في المملكة العربية السعودية 2026، موعد بدء الدراسة في السعودية 2026.";
const OG_URL = "https://do-calculate.com/articles-ar/schooldaySA/";
function MothersDay() {
  const calculateTimeLeft = (targetDate) => {
    const now = new Date();
    const difference = targetDate - now;
    let timeLeft = {};
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };
  const initialDate = new Date("2026-06-26T00:00:00");
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(initialDate));
  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft(initialDate));
    }, 1000);
    return () => clearTimeout(timer);
  }, [timeLeft]);
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <FirstAds />
      </div>
      <h1 className="p-3 mb-2 bg-success text-white">
        كم باقي على العام الدراسي الجديد 1447 في المملكة العربية السعودية
      </h1>
      <div>
        <BlinkingText text="كم باقي على العام الدراسي الجديد في المملكة العربية السعودية: من المتوقع أن يكون العام الدراسي الجديد 1447 في المملكة العربية السعودية يوم الأحد بتاريخ 26-06-2026 ميلادي أو 01/01/1447 هجري." />
      </div>
      <div className="row">
        <div id="timer" style={{ width: "100%", fontSize: "40px" }}>
          <table
            style={{
              width: "100%",
              textAlign: "center",
              borderCollapse: "collapse",
              border: "1px solid #ccc",
            }}
          >
            <thead>
              <tr>
                <th >يوم</th>
                <th >ساعة</th>
                <th >دقيقة</th>
                <th >ثوانٍ</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td id="days">{timeLeft.days}</td>
                <td id="hours">{timeLeft.hours}</td>
                <td id="minutes">{timeLeft.minutes}</td>
                <td id="seconds">{timeLeft.seconds}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="row">
        <SecondAds />
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <h3 className="p-3 mb-2 bg-success text-white">
            كم باقي على العام الدراسي الجديد في المملكة العربية السعودية 2026
          </h3>
          <p>
            في هذا المقال، نقدم لكم العد التنازلي المفصل للعام الدراسي الجديد
            2026 في المملكة العربية السعودية، لتكونوا على اطلاع دائم بكم يوم
            باقٍ على وصول هذا اليوم المميز. الكثير منا يتسائلون كم باقي على
            العام الدراسي الجديد، لهذا نقدم لكم في هذا المقال العد التنازلي
            للعام الدراسي الجديد 2026 لتتمكنوا من معرفة كم باقي على العام
            الدراسي الجديد في المملكة العربية السعودية 2026، كم يوم باقي على
            العام الدراسي الجديد في المملكة العربية السعودية شاهدوا العد
            .التنازلي للعام الدراسي الجديد 2026 في الأعلى.
          </p>
          <p>
            وفقا لموقع{" "}
            <a href="/calculator/ar/gregorian_to_hijri/">تحويل التاريخ</a> يصادف
            العام الدراسي الجديد في المملكة العربية السعودية 2026 يوم الأحد
            24-08-2026 ميلادي
          </p>
          <p>
            تجدون هنا العد التنازلي للعام الدراسي الجديد، حيث يمكنكم معرفة كم
            باقي يوم على العام الدراسي الجديد في المملكة العربية السعودية.
          </p>
          <hr />
          <RelatedLinks />
          <hr />
          <h3 className="p-3 mb-2 bg-success text-white">
            احسب كم باقي للعام الدراسي الجديد 2026
          </h3>
          <p>
            من خلال برنامج حساب العد التنازلي للعام الدراسي الجديد 2026 في
            المملكة العربية السعودية، يمكنكم معرفة كم باقي للعام الدراسي الجديد
            2026 بالتقويم الميلادي والهجري. كما يمكنكم معرفة كم باقي على العام
            الدراسي الجديد في المملكة العربية السعودية بالأيام. يمكنكم معرفة كم
            تبقى للعام الدراسي الجديد 2026 بالأيام، ومتى يبدأ العام الدراسي
            الجديد في المملكة العربية السعودية.
          </p>
          <h3 className="p-3 mb-2 bg-success text-white">
            العام الدراسي الجديد في المملكة العربية السعودية
          </h3>
          <p>
            العام الدراسي الجديد في المملكة العربية السعودية هو حدث سنوي مهم
            ينتظره الطلاب وأولياء الأمور بفارغ الصبر. هو يوم يبدأ فيه الطلاب
            رحلة تعليمية جديدة مليئة بالتحديات والفرص. يتم التحضير لهذا اليوم من
            خلال تجهيز الحقائب المدرسية، وشراء الكتب والأدوات الدراسية، والتأكد
            من جاهزية الزي المدرسي. يبدأ العام الدراسي الجديد في المملكة العربية
            السعودية في 31 أغسطس 2026، ويعد هذا اليوم بداية لفصل دراسي جديد مليء
            بالتعلم والنمو الأكاديمي والشخصي.
          </p>
          <div>
            <br />
            <img
              src={imageUrl}
              alt="كم باقي على العام الدراسي الجديد في المملكة العربية السعودية"
              width="800"
              height="450"
              style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
              loading="lazy"
            />
            <br />
          </div>
        </div>
        <div className="col" style={{ paddingTop: "28px" }}>
          <MainCalculatorsList></MainCalculatorsList>
        </div>
        <br />
      </div>
    </div>
  );
}
export default MothersDay;
